angular.module('v3sWbtPlayerApp').factory('v3sViewportChangeCheckerService', ["$window", "v3sContentConfig", "v3sNavigationService", "v3sServiceFinder", "$timeout", "v3sMediaService",  function ($window, v3sContentConfig, v3sNavigationService, v3sServiceFinder, $timeout, v3sMediaService) {

    var v3sToolsService = v3sServiceFinder.get("v3sToolsService");

    var viewport = 'desktop';
    var maxWidth = v3sContentConfig.width - 1;
    var testSco;
    var currMedia = null;
    var videoIsPlaying = false;
    function setViewport() {
        viewport = !!window.matchMedia && v3sContentConfig.responsive ? (!!window.matchMedia("(max-width: "+ maxWidth +"px)").matches) ? 'responsive': 'desktop' : 'desktop';
        return viewport;
    }
    setViewport();

    function updateView() {
        var oldView = viewport;
        var newView = setViewport();
        testSco = v3sNavigationService.getItem("test");
        currMedia = v3sMediaService.getCurrentMedia();
        videoIsPlaying = (!!currMedia && !!currMedia.video) ? currMedia.isPlaying() : false;
        var testIsRunning = !!testSco ? testSco.getTest().isRunning() : false;
        if (oldView !== newView && !testIsRunning && !videoIsPlaying) {
            v3sNavigationService.reload();
            //Der Baum wird geschlossen
            if (v3sToolsService) {
                v3sToolsService.hideTree();
            }

        }
    }

    if (v3sContentConfig.responsive) {
        angular.element($window).on("resize", function () {
            updateView();
            $timeout(updateView, 300);
        });
    }

    return {
    }
}]);